import { NgModule } from '@angular/core';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { EqualizationRuleModalComponent } from './equalization.rule.modal.component';
import { EqualizationRulesPanelComponent } from './equalization.rules.panel.component';
import { EqualizationRuleListGridActionCellRendererComponent } from './agGridActionCellRenderer.component';

@NgModule({
    imports: [WeissmanSharedModule],
    declarations: [
        EqualizationRuleModalComponent,
        EqualizationRulesPanelComponent,
        EqualizationRuleListGridActionCellRendererComponent
    ],
    exports: [EqualizationRulesPanelComponent]
})
export class EqualizationRuleModule {}
